import SupportOpen from "@pages/Support/Open";
import Open from "@pages/Support/Open";
import OpenDetails from "@pages/Support/Edit/OpenDetails";
import SupportInprogress from "@pages/Support/InProgress";
import SupportClosed from "@pages/Support/Closed";
import SupportAdd from "@pages/Support/Add/OpenDetails";

export const SupportRoutes = [
  //Support
  {
    path: "/support/open",
    name: "support_support_open",
    component: SupportOpen,
  },
  {
    path: "/support/inprogress",
    name: "support_support_in_progress",
    component: SupportInprogress,
  },
  {
    path: "/support/closed",
    name: "support_support_closed",
    component: SupportClosed,
  },

  {
    path: "/support/:main_route/add",
    name: "support_support_open",
    component: SupportAdd,
  },

  {
    path: "/support/open/details/:id",
    name: "support_support_open",
    component: OpenDetails,
  },
  {
    path: "/support/inprogress/details/:id",
    name: "support_support_in_progress",
    component: OpenDetails,
  },
  {
    path: "/support/closed/details/:id",
    name: "support_support_closed",
    component: OpenDetails,
  },
];
